<!-- <!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <link rel="stylesheet" href="../../assets/css/vendor.css" />
    <link rel="stylesheet" href="../../assets/css/style.css" />

    <title>Homepage</title>
  </head>
  <body id="top"> -->


    <!-- header -->
    <header class="header header-sticky header-minimal-dark">
      <div class="container">
        <div class="row">
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a href="../../index.html" class="navbar-brand"><img src="../../assets/images/logo-white.svg" alt="Logo"></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                  <a class="nav-link" href="../../index.html">Home</a>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="dropdown-1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Documentation
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdown-1">
                    <a class="dropdown-item" href="../../html/docs/layout-1.html">Layout 1</a>
                    <a class="dropdown-item" href="../../html/docs/layout-2.html">Layout 2</a>
                    <a class="dropdown-item" href="../../html/docs/layout-3.html">Layout 3</a>
                    <a class="dropdown-item" href="../../html/docs/layout-4.html">Layout 4</a>
                  </div>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link active dropdown-toggle" href="#" id="dropdown-2" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Help Center
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdown-2">
                    <a class="dropdown-item active" href="../../html/help/homepage-1.html">Homepage 1</a>
                    <a class="dropdown-item" href="../../html/help/homepage-2.html">Homepage 2</a>
                    <a class="dropdown-item" href="../../html/help/homepage-3.html">Homepage 3</a>
                    <a class="dropdown-item" href="../../html/help/category.html">Category</a>
                    <a class="dropdown-item" href="../../html/help/category-inner.html">Category Inner</a>
                    <a class="dropdown-item" href="../../html/help/article-1.html">Article 1</a>
                    <a class="dropdown-item" href="../../html/help/article-2.html">Article 2</a>
                    <a class="dropdown-item" href="../../html/help/tutorial.html">Tutorial</a>
                  </div>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="dropdown-3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Pages
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdown-3">
                    <a class="dropdown-item" href="../../html/pages/contact.html">Contact</a>
                    <a class="dropdown-item" href="../../html/pages/changelog.html">Changelog</a>
                    <a class="dropdown-item" href="../../html/pages/faq.html">FAQ</a>
                    <a class="dropdown-item" href="../../html/pages/pricing.html">Pricing</a>
                    <a class="dropdown-item" href="../../html/pages/terms.html">Terms</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="../../html/pages/404.html">404</a>
                  </div>
                </li>
              </ul>
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="nav-link" href="../../documentation/index.html">Docs</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="../../documentation/changelog.html">Changelog</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
    <!-- / header -->


    <!-- hero -->
    <section class="hero">
      <div class="image image-overlay" style="background-image:url(../../assets/images/image-1.jpg)"></div>
      <div class="container">
      	<div class="row">
      	  <div class="col text-white">
      	    <h1 class="mb-2">What are you looking for ?</h1>
      	  </div>
      	</div>
      </div>
    </section>
    <!-- / hero -->


    <!-- categories -->
    <section class="">
      <div class="container overlay-item-top">
        <div class="row gutter-3">
          <div class="col-12">
            <!-- <div class="card">
              <div class="card-body py-2">
                <div class="row">
                  <div class="col-md-8 col-lg-10">
                    <input type="text" class="form-control form-control-minimal" placeholder="Start typing here ..." aria-label="Search">
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <button type="button" class="btn btn-block btn-primary">Search</button>
                  </div>
                </div>
              </div>
              <div class="card-footer py-2 separator-top">
                <div class="tags">
                  <a href="">email forwarding</a>
                  <a href="">changing NS servers</a>
                </div>
              </div>
            </div> -->
          </div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-link2 icon-boxed icon-boxed-lg mb-3 bg-blue text-white"></span>
        	      <h3 class="card-title mb-1">Get Started</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
        	      <a href="#" class="eyebrow link text-blue">Read More</a>
        	    </div>
        	  </div>
        	</div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-command icon-boxed icon-boxed-lg mb-3 bg-orange text-white"></span>
        	      <h3 class="card-title mb-1">Company Settings</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                <a href="#" class="eyebrow link text-orange">Read More</a>
        	    </div>
        	  </div>
        	</div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-user2 icon-boxed icon-boxed-lg mb-3 bg-purple text-white"></span>
        	      <h3 class="card-title mb-1">Contacts</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                <a href="#" class="eyebrow link text-purple">Read More</a>
        	    </div>
        	  </div>
        	</div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-at-sign icon-boxed icon-boxed-lg mb-3 bg-green text-white"></span>
        	      <h3 class="card-title mb-1">Inventory</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                <a href="#" class="eyebrow link text-green">Read More</a>
        	    </div>
        	  </div>
        	</div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-credit-card2 icon-boxed icon-boxed-lg mb-3 bg-red text-white"></span>
        	      <h3 class="card-title mb-1">Sales</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                <a href="#" class="eyebrow link text-red">Read More</a>
        	    </div>
        	  </div>
        	</div>
            <div class="col-md-6 col-lg-4">
                <div class="card stacked text-center">
                  <div class="card-body">
                    <span class="icon-credit-card2 icon-boxed icon-boxed-lg mb-3 bg-red text-white"></span>
                    <h3 class="card-title mb-1">Collections</h3>
                    <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                  <a href="#" class="eyebrow link text-red">Read More</a>
                  </div>
                </div>
              </div>
        	<div class="col-md-6 col-lg-4">
        	  <div class="card stacked text-center">
        	    <div class="card-body">
        	      <span class="icon-award icon-boxed icon-boxed-lg mb-3 bg-pink text-white"></span>
        	      <h3 class="card-title mb-1">Reports</h3>
        	      <p class="card-text mb-2">Safely store your ETH and other Ethereum crypto-assets.</p>
                <a href="#" class="eyebrow link text-pink">Read More</a>
        	    </div>
        	  </div>
        	</div>
        </div>
      </div>
    </section>
    <!-- / categories -->



    <!-- go top -->
    <div class="half">
      <span class="half-bg"></span>
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <div class="btn-frame bg-light">
              <a data-scroll href="#top" class="btn btn-top btn-white btn-ico btn-lg btn-rounded"><span class="icon-arrow-up2 fs-22"></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- / go top -->



		<!-- latest posts -->
    <!-- <section class="pt-5">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <h2 class="mb-0">Recent Entries</h2>
          </div>
        </div>
        <div class="row">
        	<div class="col">
        		<a href="" class="topic bordered">
        		  <span class="topic-label bg-green" data-toggle="tooltip" data-placement="top" title="Email"></span>
        		  <div class="row align-items-center">
        		    <div class="col-md-7">
        		      <h4 class="topic-title">Unlock my domain</h4>
        		    </div>
        		    <div class="col">
        		      <time datetime="2018-11-10 20:00" class="small text-muted">1 minute ago</time>
        		    </div>
        		    <div class="col text-right">
                  <span class="small text-muted">210 likes</span>
        		    </div>
        		  </div>
        		</a>
        		<a href="" class="topic bordered">
        		  <span class="topic-label bg-red" data-toggle="tooltip" data-placement="top" title="Payments"></span>
        		  <div class="row align-items-center">
        		    <div class="col-md-7">
        		      <h4 class="topic-title">Change domain contact information</h4>
        		    </div>
        		    <div class="col">
        		      <time datetime="2018-11-10 20:00" class="small text-muted">30 minute ago</time>
        		    </div>
        		    <div class="col text-right">
                  <span class="small text-muted">10 likes</span>
        		    </div>
        		  </div>
        		</a>
        		<a href="" class="topic bordered">
        		  <span class="topic-label bg-orange" data-toggle="tooltip" data-placement="top" title="Hosting"></span>
        		  <div class="row align-items-center">
        		    <div class="col-md-7">
        		      <h4 class="topic-title">Update contact information for domains with privacy</h4>
        		    </div>
        		    <div class="col">
        		      <time datetime="2018-11-10 20:00" class="small text-muted">1 hour ago</time>
        		    </div>
        		    <div class="col text-right">
                  <span class="small text-muted">120 likes</span>
        		    </div>
        		  </div>
        		</a>
        		<a href="" class="topic bordered">
        		  <span class="topic-label bg-blue" data-toggle="tooltip" data-placement="top" title="Domains"></span>
        		  <div class="row align-items-center">
        		    <div class="col-md-7">
        		      <h4 class="topic-title">Renewing my expired domain name</h4>
        		    </div>
        		    <div class="col">
        		      <time datetime="2018-11-10 20:00" class="small text-muted">1 day ago</time>
        		    </div>
        		    <div class="col text-right">
                  <span class="small text-muted">21 likes</span>
        		    </div>
        		  </div>
        		</a>
            <a href="" class="topic bordered">
              <span class="topic-label bg-blue" data-toggle="tooltip" data-placement="top" title="Domains"></span>
              <div class="row align-items-center">
                <div class="col-md-7">
                  <h4 class="topic-title">Recovering expired domain names</h4>
                </div>
                <div class="col">
                  <time datetime="2018-11-10 20:00" class="small text-muted">5 days ago</time>
                </div>
                <div class="col text-right">
                  <span class="small text-muted">120 likes</span>
                </div>
              </div>
            </a>
        	</div>
        </div>
      </div>
    </section> -->
    <!-- / latest posts -->


    <!-- cta -->
    <div class="half">
      <span class="half-bg"></span>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="boxed no-border bg-primary text-white">
              <div class="row gutter-0 align-items-center separated">
                <div class="col-12 col-md-6">
                  <div class="d-flex align-items-center justify-content-center py-5">
                    <div class="mr-3">
                      <span class="icon-message-circle fs-24 text-white"></span>
                    </div>
                    <div>
                      <h3 class="mb-0">Live Chat</h3>
                      <a href="" class="eyebrow eyebrow-sm link">Chat with our live support</a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="d-flex align-items-center justify-content-center py-5">
                    <div class="mr-3">
                      <span class="icon-mail fs-24 text-white"></span>
                    </div>
                    <div>
                      <h3 class="mb-0">Support Ticket</h3>
                      <a href="" class="eyebrow eyebrow-sm action">Submit a ticket</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- / cta -->

    <!-- footer -->
    <footer>
      <div class="container">
        <div class="row gutter-3">
          <div class="col-12 col-md-2">
            <a href="../../index.html"><img src="../../assets/images/logo-white.svg" alt="Logo"></a>
          </div>
          <div class="col-12 col-md-6 text-white">
            <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <div class="row">
              <div class="col">
                <ul class="list-group list-group-minimal">
                  <li class="list-group-item"><a href="" class="link">Product Help</a></li>
                  <li class="list-group-item"><a href="" class="link">Training Videos</a></li>
                  <li class="list-group-item"><a href="" class="link">Integrations</a></li>
                </ul>
              </div>
              <div class="col">
                <ul class="list-group list-group-minimal">
                  <li class="list-group-item"><a href="" class="link">REST API</a></li>
                  <li class="list-group-item"><a href="" class="link">Corporate</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-2 ml-auto text-md-right">
            <div class="dropdown">
              <button class="btn btn-inverted btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                English
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#">French</a>
                <a class="dropdown-item" href="#">German</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- / footer -->

    <!-- <script src="../../assets/js/vendor.min.js"></script> -->
    <!-- <script src="../../assets/js/app.js"></script> -->
  <!-- </body> -->
<!-- </html> -->
